import React, { FunctionComponent } from 'react';
import Layout from './components/layout/Layout';
import 'prismjs/themes/prism-okaidia.css';
import 'prismjs/plugins/line-numbers/prism-line-numbers.css';

export const wrapPageElement: FunctionComponent<any> = ({ element, props }) => {
  return <Layout {...props}>{element}</Layout>;
};
